import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert,
  Badge,
  BadgeVariations,
  Divider,
  Card,
  Link,
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { checkClienteAPI, getClienteAPI, modifyClienteAPI } from "../../data/api";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdArrowBack, MdArrowForward, MdArrowRightAlt } from "react-icons/md";
import ClienteSchedaFields from "./ClienteSchedaFields";
import ReferenteSchedaFields from "./ReferenteSchedaFields";
import { json } from "stream/consumers";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39",
  Referenti: []
};

const ClienteScheda = (props) => {
  const [loading, setLoading] = useState(true);
  const [emptyState, setEmptyState] = useState(false);
  const [error, setError] = useState(false);
  const [loadingStampa, setLoadingStampa] = useState(false);
  const [errorStampa, setErrorStampa] = useState(false);
  const [loadingContratto, setLoadingContratto] = useState(false);
  const [errorContratto, setErrorContratto] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idCliente = queryParams.get('id');
  const referentiRef = useRef(null);

  // modify ClienteBozza form data
  const [cliente, setCliente] = useState(defaultForm); // the data on the DB

  const getCliente = async (id) => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const clienteResponse = await getClienteAPI(id);
      setCliente(clienteResponse);
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        setEmptyState(true);
      } else {
        console.log('Loading cliente '+id+' failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    getCliente(idCliente);
  }, []);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to='/clienti' className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
      {
        loading ? <Loader/> : 
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">Cliente non trovato</Alert> :
        <>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '10px'
          }}>
            <h2>Scheda di {cliente?.Cognome} {cliente?.Nome}</h2>
            <View>
              <Button onClick={() => navigate('/clienti/edit?id='+idCliente)} marginLeft="15px" >Modifica dati</Button>
            </View>
        </div>
          <Link onClick={() => referentiRef?.current?.scrollIntoView({ behavior: "smooth" })}
              >Vai ai referenti <Icon as={MdArrowForward}></Icon></Link>
          <ClienteSchedaFields
              value={cliente}
              savedValue={cliente}>
          </ClienteSchedaFields>
          <hr/>
          <View marginBottom="20px" ref={referentiRef}><h2>Referenti</h2></View>
            { cliente.Referenti?.length > 0 ?
              (cliente.Referenti)?.map((r, index) => {
                return <Card variation="elevated" marginBottom="20px">             
                  <View columnSpan={[1,1,1,4]}><Text marginBottom="5px"><h4>Referente #{index+1}</h4></Text></View><ReferenteSchedaFields
                      value={cliente.Referenti?.[index] ?? defaultForm}
                      savedValue={cliente.Referenti?.[index] ?? defaultForm}>
                  </ReferenteSchedaFields></Card>
                }
              ) : "-"
            }            
        </>
      }
      </View>
    </View>
  );
};

export default ClienteScheda;
